/* eslint-disable @typescript-eslint/no-floating-promises */
import i18n, { InitOptions, LanguageDetectorAsyncModule, Services } from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/en/translation.json";
import translationFR from "./locales/fr/translation.json";

const languageDetectorPackage: LanguageDetectorAsyncModule = {
	type: "languageDetector",
	async: true,
	init: (_services: Services, _detectorOptions: object, _i18nextOptions: InitOptions) => {},
	detect: (callback) => {
		callback("en");
	},
};

export const resources = {
	en: {
		translation: translationEN,
	},
	fr: {
		translation: translationFR,
	},
};

// IMPORTANT: create a separate i18n instance. DO NOT override the i18n instance defined in chrome extension or frontend/verity
const i18nPackage = i18n.createInstance();

i18nPackage
	.use(languageDetectorPackage)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: "en",
		interpolation: {
			escapeValue: false,
		},
	});

export const packageLanguageChanger = async (language: string) => {
	await i18nPackage.changeLanguage(language);
};

export default i18nPackage;

// recursively get all paths and flatten via union
type LeafPaths<T> = {
	[K in keyof T]: T[K] extends object ? `${K & string}.${LeafPaths<T[K]>}` : K & string;
}[keyof T];

// keep the stuff after the last dot
type StripPrefix<Full extends string, Prefix extends string> = Full extends `${Prefix}.${infer Rest}` ? Rest : never;

// same as leaf, but now only union of all object paths
type AllObjectPaths<T> = {
	[K in keyof T]: T[K] extends object ? (K & string) | `${K & string}.${AllObjectPaths<T[K]>}` : never;
}[keyof T];

// given any valid prefix, return the possible leaf suffixes
export type TranslationSuffix<Prefix extends AllObjectPaths<typeof translationEN>> = StripPrefix<
	LeafPaths<typeof translationEN>,
	Prefix
>;
